import { useEffect, useRef, RefObject } from 'react';

type UseDropdownOptions = {
  isOpen: boolean;
  onClose: () => void;
  anchorRef: React.RefObject<HTMLElement | null>;
  dropdownRefs?: React.RefObject<HTMLElement | null>[];
};

// TODO: refactor, use better approach
export function useDropdown({
  isOpen,
  onClose,
  anchorRef,
  dropdownRefs,
}: UseDropdownOptions): RefObject<HTMLDivElement | null> {
  const defaultRef = useRef<HTMLDivElement>(null);
  const refs = dropdownRefs || [defaultRef];

  // Handle click outside
  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      // Check if click is outside all dropdown refs and anchor button
      const isOutsideDropdowns = refs.every((ref) => !ref.current || !ref.current.contains(target));
      const isOutsideAnchor = !anchorRef.current || !anchorRef.current.contains(target);

      if (isOutsideDropdowns && isOutsideAnchor) {
        onClose();
      }
    };

    // Small delay to prevent immediate close on opening
    const timeoutId = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, onClose, anchorRef]);

  // Handle Escape key
  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  // Return the default ref (always HTMLDivElement) for single dropdown use
  // When dropdownRefs is provided, the hook still manages click-outside but doesn't return a ref
  return defaultRef;
}
